import { PersonSpeakingIcon, PersonSpeakingIconGlyph } from "../elements/person-speaking-icon";
export var LessonIcon = PersonSpeakingIcon;
export var LessonIconGlyph = PersonSpeakingIconGlyph;